import React from 'react';
import PropTypes from 'prop-types';
import BSModal from 'react-bootstrap/Modal';
import styles from './Modal.module.scss';

const Modal = ({ show, onHide, title, size, children, footer, className }) => {
  const classNames = [styles.modal, className || ''].filter(Boolean).join(' ');

  return (
    <div className={classNames}>
      <BSModal show={show} onHide={onHide} size={size} centered>
        <BSModal.Header closeButton>
          <BSModal.Title>{title}</BSModal.Title>
        </BSModal.Header>
        <BSModal.Body>{children}</BSModal.Body>
        {footer && <BSModal.Footer>{footer}</BSModal.Footer>}
      </BSModal>
    </div>
  );
};

Modal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  children: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
};

Modal.defaultProps = {
  show: false,
  onHide: () => {},
  title: '',
  size: 'md',
  children: null,
  footer: null,
  className: '',
};

export default Modal;
